"use strict";

var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./productLaunch/productLaunch"));
});
